<template lang='pug'>
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs11, sm10, md10, lg9)
          v-card(flat, text-xs-center)
            breadcrumb(back='page6-13')
              | Estás en: Elige tu Crédito Hipotecario / ¡Quiero elegir la mejor condición para contratar mi Crédito Hipotecario!
            v-card-text.text-xs-center.label16tt.withDivider(style='color:#F7893B')
              | HISTORIA 3 - ¿CÓMO PUEDE EL CRÉDITO HIPOTECARIO SER PARTE DE TU FUTURO?
            v-layout(row, wrap, justify-start, py-4)
              v-flex.ma-0.pa-0(xs12, md6)
                v-card(flat, text-xs-start)
                  v-card-media(height='600px', src='assets/TCH-L2-5-6-Pagina3A.jpg')
              v-flex.ma-0.pa-0(xs12, md6)
                v-card.pa-5(flat, height='100%', color='accent')
                  v-card-text.parrafoDestacadoW.pl-5.py-5.mt-3
                    | ¿Has considerado alguna vez al Crédito Hipotecario en tu plan de retiro? Cambiar de hogar y adquirir una segunda propiedad de descanso puede ser una realidad por medio de un Crédito Hipotecario.
                    .pt-3  Ayuda a 
                      b  Benjamín 
                      | a decidir cómo lograrlo. 
            v-layout(row, justify-center)
              v-btn.btn(justify-space-between, type='button', color='accent', @click.prevent="nextPage('page6-15')")
                | Ok, !Entendido!
          l-progress(:value='this.$parent.currentPage')

</template>

<script>
import {
  eventBus
} from '../main';
export default {
  name: 'app',
  data() {
    return {
      progress: false
    }
  },
  methods: {
    nextPage(page) {
      this.progress = true;
      eventBus.$emit('next_page', page);
    },
    nextChapter(page) {
      this.progress = true;
      eventBus.$emit('next_chapter', page);
    },
    lastPage(page) {
      this.progress = true;
      eventBus.$emit('last_page', page);
    }
  }
};
</script>
